import * as React from 'react'
import * as style from './mhContainer.module.css'
const MHContainer = ({ children }) => {
//Here are my default styles:

  return (
  <>
  <div className={style.overlay}></div>
  <div className="container-fluid">
      <div className="row">
          <div className="col-12">
              <div className="d-flex h-100 align-items-center">
                  <div className="p-2 headerTextBackground w-100">
                    {children}
                  </div>
              </div>
          </div>
      </div>
  </div>
</>
  )
}

export default MHContainer